export default __webpack_public_path__ + "static/garden_design10-b3b4c4590e4217f27855c0d7720baa16.webp";